module.exports = __webpack_public_path__ + "static/media/midhappy3.d92d922f.png";